import apiV1 from 'redux/api/v1';
import { GET_PROJECTS, GET_CONFIGS } from 'constants/endpoints';

export const GET_PROJECTS_LIST_LOADING = 'project/list/GET_PROJECTS_LIST_LOADING';
export const GET_PROJECTS_LIST_FULFILLED = 'project/list/GET_PROJECTS_LIST_FULFILLED';
export const GET_PROJECTS_LIST_REJECTED = 'project/list/GET_PROJECTS_LIST_REJECTED';

export const GET_CONFIGS_LOADING = 'project/list/GET_CONFIGS_LOADING';
export const GET_CONFIGS_FULFILLED = 'project/list/GET_CONFIGS_FULFILLED';
export const GET_CONFIGS_REJECTED = 'project/list/GET_CONFIGS_REJECTED';

// TODO: Add pagination and sorting
export function fetchListing(pagination, sort) {
  return async function (dispatch) {
    dispatch({ type: GET_PROJECTS_LIST_LOADING });
    try {
      const list = await apiV1.get(GET_PROJECTS);
      dispatch({ type: GET_PROJECTS_LIST_FULFILLED, data: { list } });
    } catch(error) {
      dispatch({ type: GET_PROJECTS_LIST_REJECTED, data: { error } });
    }
  };
}

export function fetchConfigs() {
  return async function (dispatch) {
    dispatch({ type: GET_CONFIGS_LOADING });
    try {
      const configs = await apiV1.get(GET_CONFIGS);
      dispatch({ type: GET_CONFIGS_FULFILLED, data: { configs } });
    } catch(error) {
      dispatch({ type: GET_CONFIGS_REJECTED, data: { error } });
    }
  };
}